import React from 'react';
import { Result, Button } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const AccessDenied: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('common');

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      minHeight: '100vh',
      background: '#f0f2f5'
    }}>
      <Result
        status="403"
        icon={<LockOutlined style={{ fontSize: 72, color: '#ff4d4f' }} />}
        title={t('accessDenied.title', 'Access denied')}
        subTitle={t('accessDenied.subtitle', 'Sorry, you do not have permission to access this page.')}
        extra={
          <Button type="primary" onClick={() => navigate('/dashboard')}>
            {t('accessDenied.backToDashboard', 'Back to dashboard')}
          </Button>
        }
      />
    </div>
  );
};

export default AccessDenied;
